import { SVG_ENUM } from "enums";
import { SVG } from "shared";
import "./SocialIcons.scss";

const SOCIAL_LINKS = [
  { href: "https://www.facebook.com/reliancepolska/", icon: SVG_ENUM.FB_ICON },
  {
    href: "https://pl.linkedin.com/company/reliancepolska",
    icon: SVG_ENUM.LINKD_ICON,
  },
  {
    href: "https://www.instagram.com/relianceholding/",
    icon: SVG_ENUM.IG_ICON,
  },
  { href: "https://x.com/ReliancePolska", icon: SVG_ENUM.X_ICON },
];

const SocialIcons: React.FC = () => {
  return (
    <div className="social-icons">
      {SOCIAL_LINKS.map(({ href, icon }) => (
        <a key={icon} href={href} target="_blank" rel="noreferrer">
          <SVG type={icon} className="social-icons__icon" />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
